/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { Select, SelectProps } from '@mantine/core'
import { parseBoolean } from '@jalik/form-parser'
import FormField from '../../../../client/js/components/form/fields/FormField'

export type ManagedFieldProps = Omit<SelectProps, 'data'> & {
  nullable?: boolean;
}

function ManagedField (props: ManagedFieldProps) {
  const {
    name = 'managed',
    nullable,
    ...others
  } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'management',
        defaultMessage: 'Gestion'
      })}
      {...others}
      name={name}
      render={Select}
      parser={parseBoolean}
      data={[
        {
          label: intl.formatMessage({
            id: 'undefined',
            defaultMessage: 'Non défini'
          }),
          value: ''
        },
        {
          label: intl.formatMessage({
            id: 'managed',
            defaultMessage: 'Géré'
          }),
          value: 'true'
        },
        {
          label: intl.formatMessage({
            id: 'not_managed',
            defaultMessage: 'Non géré'
          }),
          value: 'false'
        }
      ].filter((el) => nullable || el.value !== '')}
    />
  )
}

export default ManagedField
